// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-dot-icon lucide-dot\"><circle cx=\"12.1\" cy=\"12.1\" r=\"1\"/></svg>";
// Exports
module.exports = code;